import { Eyebrow, Reveal } from "@/components/Reveal";

const PHOTOS = [
  { src: "/images/child-thankful-affirmations.jpg", caption: "Feeling thankful with Bailey's Affirmations", rotate: "-rotate-1" },
  { src: "/images/child-reading-bailey.jpeg", caption: "Morning affirmations, done right", rotate: "-rotate-2" },
  { src: "/images/gallery-child-reading-1.jpeg", caption: "Bailey Starts School — first day ready", rotate: "rotate-1" },
  { src: "/images/child-certificate.jpeg", caption: "A proud Team Bailey graduate", rotate: "-rotate-1" },
  { src: "/images/gallery-child-reading-2.jpeg", caption: "One more page before bed", rotate: "rotate-2" },
  { src: "/images/child-reading-school.jpeg", caption: "Story time, classroom edition", rotate: "-rotate-2" },
  { src: "/images/child-books-table.jpeg", caption: "The whole collection, collected", rotate: "rotate-1" },
];

export default function Gallery() {
  return (
    <section data-testid="gallery-section" className="py-24 sm:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center mb-16">
          <Eyebrow className="mb-4">Real stories, real impact</Eyebrow>
          <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-walnut">
            Real children. Real confidence.
          </h2>
          <p className="mt-4 max-w-xl mx-auto text-sm sm:text-base text-walnutsoft leading-relaxed">
            Children across the UK are building confidence, celebrating their uniqueness,
            and falling in love with reading through Bailey's adventures.
          </p>
        </Reveal>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
          {PHOTOS.map((p, i) => (
            <Reveal key={p.src} delay={(i % 3) * 0.1}>
              <figure
                data-testid={`gallery-photo-${i}`}
                className={`group bg-white border border-sand rounded-2xl p-3 pb-4 shadow-[0_14px_30px_-18px_rgba(44,34,30,0.3)] ${p.rotate} hover:rotate-0 hover:-translate-y-2 transition-transform duration-500`}
              >
                <div className="overflow-hidden rounded-xl">
                  <img
                    src={p.src}
                    alt={p.caption}
                    loading="lazy"
                    className="w-full aspect-[4/5] sm:aspect-square object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <figcaption className="pt-3 px-1 font-mono text-[11px] sm:text-xs text-walnutsoft tracking-wide">
                  {p.caption}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
